window.addEventListener('DOMContentLoaded', function() {
  const atcBtn = document.querySelector('.product-form__submit')
  
  const disableAtcBtn = () => {
    atcBtn.disabled = true
  }
  
  const unselectOptions = () => {
    const selectedOptionInputs = document.querySelectorAll('variant-options input[checked]')
    
    selectedOptionInputs.forEach(input => input.removeAttribute('checked'))
  }
  
  const setupOptionSelectListeners = () => {
    const optionInputs = document.querySelectorAll('variant-options input')
    const optionsCount = document.querySelectorAll('.product-form__input').length
    
    atcBtn.innerHTML = 'Bitte wähle deine Düfte'
    atcBtn.style.pointerEvents = 'none'
    atcBtn.style.opacity = '1'
    atcBtn.style.color= '#efeae4'
    
    optionInputs.forEach(input => {
      input.addEventListener('change', () => {
        const selectedOptionInputsArr =  Array.from(optionInputs).filter(input => input.checked)

        if (selectedOptionInputsArr.length == optionsCount) {
          atcBtn.innerHTML = 'In den Warenkorb'
          atcBtn.style.pointerEvents = 'auto'
        } else {
          atcBtn.innerHTML = 'Bitte wähle deine Düfte'
        }
      })
    })
  }

  const setupOptions = () => {
    unselectOptions()
    setupOptionSelectListeners()
  }


  const init = () => {
    // disableAtcBtn()
    setupOptions()
    unselectOptions()
  }

  init()
});
